export default __webpack_public_path__ + "static/media/img_code.58479d1d.png";